const text = document.querySelector('.info__text');
const boxShadowWrap = document.querySelector('.info__content-shadow');

if (text) {
    text.addEventListener('scroll', () => {
        boxShadowWrap.style.display = 'none'
    });
}

